import middlewares from '@/presentation/middlewares';

const middlewaresInitializer = (router) => {
	for (const middleware of Object.values(middlewares)) {
		middleware(router);
	}
};

export default middlewaresInitializer;
